module.exports = __webpack_public_path__ + "img/404.6074330b.png";